import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-side-bar-layout',
  templateUrl: './side-bar-layout.component.html',
  styleUrls: ['./side-bar-layout.component.scss'],
})
export class SideBarLayoutComponent implements OnInit {
  @Input() title: string;

  constructor() {}

  ngOnInit(): void {}
}
